module.exports = __webpack_public_path__ + "static/img/bcg2.f958dc70.webp";